import React, {forwardRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "common/hook";
import {ROLE_HR, ROLE_TEACHER} from "entities/constants/constants";
import {clearFilters, setFilters} from "features/model/slice/groups/filters-slice/filtersSlice";

interface Filters {
    isNew: boolean;
    finished: boolean;
    has_problem: boolean;
}


interface StudentsFilterComponentProps {
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    setShowFilter: (showFilter: boolean) => void;
    showFilter: boolean;
    setSendFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const StudentsFilterComponent = forwardRef<HTMLDivElement, StudentsFilterComponentProps>(
    ({onClick, setShowFilter, showFilter, setSendFilter}, ref) => {
        const dispatch = useAppDispatch();
        const roleType = useAppSelector((state) => state.role.roleType);
        const [selectedItems, setSelectedItems] = useState<string[]>([]);
        const pendingFilters = useAppSelector((state) => state.filers);


        const handleFilterComponentClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            event.stopPropagation();
            onClick(event);
        };

        const handleProblemChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const {id, checked} = event.target;

            // Create a separate object with a well-defined structure
            const updatedFilter: Partial<Filters> = {
                [id]: checked,
            };

            // Merge it with the existing Filters object using the spread operator
            dispatch(setFilters({...updatedFilter} as Filters));

            setSelectedItems((prevSelectedItems) =>
                checked ? [...prevSelectedItems, id] : prevSelectedItems.filter((item) => item !== id)
            );
        };


        const handleClearFilter = () => {
            setSendFilter(false);
            dispatch(clearFilters());
            setSelectedItems([]);
        };


        const handleApplyFilter = () => {
            setShowFilter(!showFilter);
            setSendFilter(prev => !prev);
        };


        return (
            <div
                ref={ref} className='filter-container'
                onClick={handleFilterComponentClick}>
                <div className="filter-item-container">
                    <div className={`filter-item ${selectedItems.includes('isNew') ? 'selected' : ''}`}>
                        <input
                            type="checkbox"
                            id="isNew"
                            checked={pendingFilters.isNew}
                            onChange={handleProblemChange}/>
                        <label htmlFor="isNew">Новое занятие</label>
                    </div>
                    <div className={`filter-item ${selectedItems.includes('finished') ? 'selected' : ''}`}>
                        <input
                            type="checkbox"
                            id="finished"
                            checked={pendingFilters.finished}
                            onChange={handleProblemChange}/>
                        <label htmlFor="finished">Занятие завершено</label>
                    </div>
                    {(roleType === ROLE_TEACHER || roleType === ROLE_HR) && (
                        <div className={`filter-item ${selectedItems.includes('has_problem') ? 'selected' : ''}`}>
                            <input
                                type="checkbox"
                                id="has_problem"
                                checked={pendingFilters.has_problem}
                                onChange={handleProblemChange}
                            />
                            <label htmlFor="has_problem">Наличие проблемы</label>
                        </div>
                    )}
                </div>

                <div className="filter-item-btns">
                    <button onClick={handleClearFilter} className="js-clear-values">
                        Очистить
                    </button>
                    <button
                        style={{margin: '0'}}
                        onClick={handleApplyFilter}
                        className="btn small js-apply-filter"
                        data-filter-box="courses-filtration"
                    >
                        <span>Применить</span>
                    </button>
                </div>
            </div>
        );
    }
);

